import { render, staticRenderFns } from "./model2.vue?vue&type=template&id=a8a2452e&scoped=true"
import script from "./model2.vue?vue&type=script&lang=js"
export * from "./model2.vue?vue&type=script&lang=js"
import style0 from "./model2.vue?vue&type=style&index=0&id=a8a2452e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a2452e",
  null
  
)

export default component.exports